// config
import * as http from 'utils/http';
import config from 'config';

const getCarrierUserGroups = async () => {
  //   mock
  //   const data = mock;
  //   await new Promise((resolve) => setTimeout(resolve, 3000));
  //   real
  const data = await http.get(`${config.BASE_ROUTE}api/carrier-user-groups/?page_size=200`);
  return data;
};

export default getCarrierUserGroups;
